import React from "react";
import {
  Row,
  Col,
  Space,
  message,
  Button,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import ListTable from "./ListTable";

import config from "../config";

import withRouter from "../withRouter";

import { CarOutlined, CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import AdvertisementStore from "../store/AdvertisementStore";
import { Link } from "react-router-dom";
import AdvertisementAdd from "./AdvertisementAdd";
import CompanyStore from "../store/CompanyStore";
import AssignVehicleToAdvertise from "./AssignVehicleToAdvertise";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class AdvertisementList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.advertisementStore = new AdvertisementStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      openAdvertismentForm: false,
      listDataUpdate: false,
      comp_value: "",
      openAssignForm: false,
      vehicleSelection: 0,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_COMAPNY_NAME_"),
        dataIndex: "companyName",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("advertisementList") &&
                  this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        title: context.translate("_NAME_"),
        dataIndex: "name",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_SEQUENCE_"),
        dataIndex: "sequence",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      // {
      //   title: context.translate("_INTERVAL_SEC_"),
      //   dataIndex: "playInterval",
      //   width: 15,
      //   ellipsis: {
      //     showTitle: true,
      //   },
      // },
      {
        title: context.translate("_IMAGE_VIDEO_TYPE_"),
        dataIndex: "showType",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == 1) {
            return "Full Banner";
          }
          if (value == 2) {
            return "Middle Banner";
          }
          if (value == 3) {
            return "Bottom Banner";
          }
        },
      },
      {
        title: context.translate("_DESCRIPTION_"),
        dataIndex: "description",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_PICTURE_VIEW_"),
        dataIndex: "path",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          var imagePath = config.fleetURL + record.path;
          var showType = Number(record.showType);
          var isImgVideo = Number(record.isImgVideo);
          if (showType === 1 && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (showType === 2 && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (showType === 3 && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (showType === "" && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (isImgVideo === 2) {
            //return "<img src=" + imagePath + " height='70px' width ='70px'></img>";
            return (
              <video width="280" height="70" controls>
                <source src={imagePath} type="video/mp4" />
              </video>
            );
          }
        },
        // render: (text, record) => {
        //   return (
        //     <>
        //       <img
        //         src={config.fleetURLAdvertise + record.path}
        //         alt="Image"
        //         style={{ width: "100px", height: "auto" }}
        //       />
        //     </>
        //   );
        // },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 6,
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  // title="Assign"
                  title={this.context.translate("_ASSIGN_")}
                  placement="bottom"
                  color={config.tooltipColorEdit}
                >
                  <CarOutlined
                    style={{ fontSize: "15px", marginTop: "5px" }}
                    onClick={() => {
                      this.setState({
                        openAssignForm: true,
                        advertiseId: record.id,
                        vehicleSelection: record.vehicleSelection,
                      });
                    }}
                  />
                </Tooltip>{" "}

                {this.props.canUpdate("advertisementList") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("advertisementList") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.advertisementStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      let setAdvertisementData =
        this.context.viewStateStore.advertisementObject;

      setAdvertisementData =
        typeof setAdvertisementData === "number"
          ? setAdvertisementData
          : setAdvertisementData.companyId;

      if (setAdvertisementData !== "") {
        await this.advertisementStore.loadData({
          companyId: setAdvertisementData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setAdvertisementData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setAdvertisementData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setAdvertisementStates({
      companyId: record.companyId,
    });
    await this.setState({ id: record.id });
    await this.setState({ openAdvertismentForm: true });
  };

  async onDelete(record) {
    console.log(record);
    const response = await this.advertisementStore.deleteRecord({
      id: record.id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    if (this.state.companyId > 0) {
      await this.advertisementStore.loadData({
        companyId: this.state.companyId,
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        page: this.state.currentPage,
      });
    }
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    console.log(comp.value);

    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });

    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openAdvertismentForm: false });
  };
  closeAssignZoneModal = () => {
    this.setState({ openAssignForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openAdvertismentForm: false });
      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };

  handleClear = async () => {
    await this.setState({ comp_value: null, companyId: "" });
  };
  assignresponseMsg = async (response) => {
    if (response.data.success === "S") {
      message.success(response.data.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openAssignForm: false });
      await this.handleSearch();
    } else {
      await message.error(response.data.message);
      await this.setState({ loading: false });
    }
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  onClear={this.handleClear}
                  className="searchInput"
                  onChange={this.handleChange}
                  value={this.state.comp_value ? this.state.comp_value : null}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("advertisementList") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openAdvertismentForm: true, id: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.advertisementStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.advertisementStore?.advertisementList}
            loading={this.advertisementStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openAssignForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openAssignForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
                <p className="formDescription">
                  {this.context.translate("_FLEET_ADVIST_VEHICLE_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openAssignForm: false })}
            onCancel={() => this.setState({ openAssignForm: false })}
          >
            <div height="100%">
              <AssignVehicleToAdvertise
                companyId={this.state.companyId}
                advertiseId={this.state.advertiseId}
                response={this.assignresponseMsg}
                vehicleSelection={Number(this.state.vehicleSelection)}
                // vehicleSelection={Number(2)}
                closeModal={this.closeAssignZoneModal}
              />
            </div>
          </Drawer>
          //  </Modal> 
        )}

        {this.state.openAdvertismentForm && (
          <Drawer
            className="uploadExcelDrawer"
            // title="Driver Details"
            width={716}
            closeIcon={false}
            open={this.state.openAdvertismentForm}
            footer={false}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            title={
              <div className="formTitle">
                {this.context.translate("_FILE_UPLOAD_")}
                <p className="formDescription">
                  {this.context.translate("_ADVERTISEMENT_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openAdvertismentForm: false })}
            onCancel={() =>
              this.setState({ openAdvertismentForm: false, id: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <AdvertisementAdd
                id={this.state.id}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
AdvertisementList.contextType = StoreContext;
export default observer(withRouter(AdvertisementList));
